// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__11GOs","file":"styles_file__1puBG"};